/**
 * @file: useReservationsList.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useInfiniteList } from '@euler/functions/useInfiniteList';
import { Reservation } from '@euler/model/reservation/Reservation';
import {
  ReservationListFilter,
  ReservationSorter,
} from '@euler/model/reservation/types';
import { useServiceFactory } from '@euler/services/factory';

export const useReservationsList = (
  filter: ReservationListFilter | undefined,
  options?: { sorter?: ReservationSorter; limit?: number },
) => {
  const limit = options?.limit ?? 15;
  const sorter = options?.sorter;
  const { reservationService } = useServiceFactory();
  return useInfiniteList<Reservation>({
    limit,
    keyExtractor: x => x.id,
    query: async (offset: number) => {
      return await reservationService.list(filter, offset, limit, sorter);
    },
  });
};
